import React from "react";
import { Undo, Redo, Reset } from "../Icons";
import * as THREE from "three";
import {
  undoMovementList,
  redoMovementList,
  MovementTypes,
  roundVector,
  iprOverlaysGlobalCopy,
} from "./TeethPositionHelper";
import { useGlobalStore } from "@/store";
import { rotateTooth } from "./TeethPositionHelper";
import { lockTooth } from "./TeethPositionHelper";
import { useModal } from "@/hooks/useModal";
import {
  attachmentsObjects,
  attachmentMaterial,
  subscribeAttachmentToListener,
} from "./addRemoveAttachment";
import {
  Controller,
  heatMapManager,
  attachmentMaterial as oldAttachmentMaterial,
} from "../Mesh";
import { useCustomTranslation } from "@/hooks/useTranslation";
import { removeListenersFrom } from "@/helpers/clickManager";
import {
  prepareIPRs3DControls,
  iprOverLays as globalIprOverLays,
  setIprOverlays as setGlobalIprOverLays,
} from "@/helpers/ipr";
import { generateHeatmapsByName } from "../Heatmaps";

// import { Vector3 } from "three";

export let undoRef;

function URR({
  reset,
  redo,
  reflectToChangelog,
  iprOverLays,
  setIprOverlays,
  GLBData,
  setAutoSave,
  clearAutoSave,
}) {
  const { ModalContainer: ResetModal, toggleModal: toggleReset } = useModal();

  const {
    selectedTooth,
    setControls3D,
    logs,
    setLogs,
    scene,
    attachmentArray,
    groupRef,
  } = useGlobalStore(state => ({
    selectedTooth: state.controls3D.selectedTooth,
    setControls3D: state.setControls3D,
    logs: state.logs,
    setLogs: state.setLogs,
    scene: state.scene,
    attachmentArray: state.controls3D.attachmentArray,
    groupRef: state.refs.groupRef,
  }));

  // Undo/Redo/Reset Components
  // function reflectToChangelog(theMovement, isUndo = 1) {
  //   const toothNum = theMovement.tooth.name.split("_")[2].substring(1, 4);
  //   switch (theMovement.actionType) {
  //     case MovementTypes.EXTRUSIONINTRUSION: {
  //       let factor = 1;
  //       if (theMovement.movement.y < 0) {
  //         factor = -1;
  //       }
  //       logs[toothNum + "_Movement"][MovementTypes.EXTRUSIONINTRUSION] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.EXTRUSIONINTRUSION] +
  //             toothMovementAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //     case MovementTypes.MESIALDISTAL: {
  //       let factor = 1;
  //       if (theMovement.type === "Mesial") {
  //         factor = -1;
  //       }
  //       console.log(factor);
  //       logs[toothNum + "_Movement"][MovementTypes.MESIALDISTAL] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.MESIALDISTAL] +
  //             toothMovementAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //     case MovementTypes.BUCCALLINGUAL: {
  //       let factor = 1;
  //       if (theMovement.type === "Lingual") {
  //         factor = -1;
  //       }
  //       logs[toothNum + "_Movement"][MovementTypes.BUCCALLINGUAL] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.BUCCALLINGUAL] +
  //             toothMovementAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //     case MovementTypes.ROTATION: {
  //       let factor = 1;
  //       if (theMovement.degrees < 0) {
  //         factor = -1;
  //       }
  //       logs[toothNum + "_Movement"][MovementTypes.ROTATION] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.ROTATION] +
  //             teethRotationAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //     case MovementTypes.ANGULATION: {
  //       let factor = 1;
  //       if (theMovement.degrees < 0) {
  //         factor = -1;
  //       }
  //       logs[toothNum + "_Movement"][MovementTypes.ANGULATION] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.ANGULATION] +
  //             teethRotationAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //     case MovementTypes.INCLINATION: {
  //       let factor = 1;
  //       if (theMovement.degrees < 0) {
  //         factor = -1;
  //       }
  //       logs[toothNum + "_Movement"][MovementTypes.INCLINATION] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.INCLINATION] +
  //             teethRotationAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //     case MovementTypes.LEFTHINGE: {
  //       let factor = 1;
  //       if (theMovement.degrees < 0) {
  //         factor = -1;
  //       }
  //       logs[toothNum + "_Movement"][MovementTypes.LEFTHINGE] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.LEFTHINGE] +
  //             teethRotationAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //     case MovementTypes.RIGHTHINGE: {
  //       let factor = 1;
  //       if (theMovement.degrees < 0) {
  //         factor = -1;
  //       }
  //       logs[toothNum + "_Movement"][MovementTypes.RIGHTHINGE] =
  //         Math.round(
  //           (logs[toothNum + "_Movement"][MovementTypes.RIGHTHINGE] +
  //             teethRotationAmount * factor * isUndo) *
  //             100,
  //         ) / 100;
  //       break;
  //     }
  //   }
  //   setLogs(logs);
  //   console.log(logs);
  // }
  undoRef = undo;
  function undo(addToList = true) {
    if (addToList) {
      Controller.detach();
    }
    const movedTeeth = new Set();

    let newIprOverLays = JSON.parse(JSON.stringify(globalIprOverLays));
    let isArray = false;
    let lastElem = false;
    if (undoMovementList.length > 0) {
      isArray = Array.isArray(undoMovementList[undoMovementList.length - 1]);
    }
    let movementType, toothNum, arrLen, attachmentID;
    if (!isArray) {
      movementType = undoMovementList[undoMovementList.length - 1]?.actionType;
      toothNum = undoMovementList[undoMovementList.length - 1]?.tooth.name
        .split("_")[2]
        .substring(1, 4);
    } else {
      arrLen = undoMovementList[undoMovementList.length - 1].length - 1;
      movementType =
        undoMovementList[undoMovementList.length - 1][arrLen].actionType;
      toothNum = undoMovementList[undoMovementList.length - 1][
        arrLen
      ].tooth.name
        .split("_")[2]
        .substring(1, 4);
    }
    let attContinue = true;
    while (true) {
      if (!isArray) {
        if (undoMovementList.length === 0) {
          lastElem = true;
          return;
        }
        if (
          undoMovementList[undoMovementList.length - 1].actionType !==
          MovementTypes.ATTACHMENTS
        ) {
          if (
            movementType !==
              undoMovementList[undoMovementList.length - 1].actionType ||
            (toothNum !==
              undoMovementList[undoMovementList.length - 1].tooth.name
                .split("_")[2]
                .substring(1, 4) &&
              !undoMovementList[undoMovementList.length - 1][arrLen]
                .isChunckMovement) ||
            (attachmentID
              ? getAttachmentByID(
                  undoMovementList[undoMovementList.length - 1].tooth
                    ?.children[0],
                  attachmentID,
                )
              : false)
          ) {
            break;
          }
        } else {
          if (!attContinue) {
            break;
          }
        }
        //console.log(undoMovementList);
        const t = undoMovementList.pop();
        if (t.movement) {
          t.tooth.position.add(t.movement);
          reflectToChangelog(t);
          movedTeeth.add(t.tooth.name);
        } else if (t.degrees) {
          rotateTooth(
            t.rotationPoint,
            t.teethMovementRotationDirection,
            t.degrees,
            t.tooth,
          );
          reflectToChangelog(t);
          movedTeeth.add(t.tooth.name);

          // rotateAroundPoint(t.tooth, t.rotationPoint, t.teethMovementRotationDirection, t.degrees, true)
        } else if (t.actionType === MovementTypes.LOCK) {
          setControls3D("selectedTooth", t.tooth);
          lockTooth(true, t.tooth);
        } else if (t.actionType === MovementTypes.ATTACHMENTS) {
          if (t.action === "add") {
            for (let i = 0; i < t.tooth.children[0].children.length; i++) {
              if (
                t.tooth.children[0].children[i].name == t.attachmentName &&
                t.attachmentID === t.tooth.children[0].children[i].customID
              ) {
                attachmentID = t.attachmentID;
                redoMovementList.push({
                  tooth: t.tooth,
                  action: t.action,
                  actionType: t.actionType,
                  attachmentID: t.attachmentID,
                  attachmentName: t.tooth.children[0].children[i].name,
                  relativePosition: roundVector(
                    t.tooth.children[0].children[i].position.clone(),
                  ),
                  relativeRotation: roundVector(
                    t.tooth.children[0].children[i].rotation.clone(),
                  ),
                  continue: t.continue,
                });

                let selectedToothNum = t.tooth.name
                  .split("_")[2]
                  .substring(1, 4);
                let action = "";
                if (attachmentArray[selectedToothNum]?.length > 0) {
                  for (
                    let attachmentIndex = 0;
                    attachmentIndex < attachmentArray[selectedToothNum].length;
                    attachmentIndex++
                  ) {
                    if (
                      t.attachmentID ===
                      attachmentArray[selectedToothNum][attachmentIndex]
                        .customID
                    ) {
                      action = "remove";
                      break;
                    }
                  }
                }

                let key = selectedToothNum.toString() + "_Movement";

                if (!logs[key]) {
                  logs[key] = {};
                  logs[key][MovementTypes.MESIALDISTAL] = 0;
                  logs[key][MovementTypes.BUCCALLINGUAL] = 0;
                  logs[key][MovementTypes.EXTRUSIONINTRUSION] = 0;
                  logs[key][MovementTypes.ROTATION] = 0;
                  logs[key][MovementTypes.ANGULATION] = 0;
                  logs[key][MovementTypes.INCLINATION] = 0;
                  logs[key][MovementTypes.LEFTHINGE] = 0;
                  logs[key][MovementTypes.RIGHTHINGE] = 0;
                }
                if (!logs[key].hasOwnProperty("attachment")) {
                  logs[key]["attachment"] = {};
                }
                logs[key]["attachment"][attachmentID] = {
                  action: action,
                  type: t.tooth.children[0].children[i].name,
                };

                // if (logs[key]) {
                //   const obj = Object.assign({}, logs[key]);
                //   delete logs[key];
                //   obj["attachment"][attachmentID] = {
                //     action: action,
                //     type: t.tooth.children[0].children[i].name,
                //   };
                //   logs[key] = obj;
                // } else {
                //   logs[key] = {};
                //   if (!logs[key]["attachment"]) {
                //     logs[key]["attachment"] = {};
                //   }
                //   logs[key]["attachment"][attachmentID] = {
                //     action: action,
                //     type: t.tooth.children[0].children[i].name,
                //   };
                // }
                setLogs(logs);
                removeListenersFrom(t.tooth.children[0].children[i]);
                t.tooth.children[0].children[i].removeFromParent();
                break;
              }
            }
          } else if (t.action === "remove") {
            let attachment;
            for (let i = 0; i < attachmentsObjects.length; i++) {
              if (attachmentsObjects[i].name === t.attachmentName) {
                attachment = attachmentsObjects[i].clone();
              }
            }

            let action;

            if (!attachment) {
              // old attachment
              const toothNumberKey = t.tooth.name.split("_")[2].substring(1);
              for (
                let attachmentIndex = 0;
                attachmentIndex < attachmentArray[toothNumberKey].length;
                attachmentIndex++
              ) {
                if (
                  attachmentArray[toothNumberKey][attachmentIndex].customID ==
                  t.attachmentID
                ) {
                  attachment =
                    attachmentArray[toothNumberKey][attachmentIndex].clone();
                  attachment.name = "_att";
                  attachment.material = oldAttachmentMaterial;
                  break;
                }
              }
              action = "";
            } else {
              action = "add";
              attachment.material = attachmentMaterial;
            }
            if (!attachment) {
              console.log("WARNINGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG");
            }
            t.tooth.children[0].attach(attachment);
            attachment.customID = t.attachmentID;
            subscribeAttachmentToListener(attachment);

            attachment.position.copy(t.relativePosition);
            attachment.rotation.copy(t.relativeRotation);
            attachment.visible = true;

            redoMovementList.push({
              tooth: t.tooth,
              action: t.action,
              attachmentID: t.attachmentID,
              attachmentName: t.attachmentName,
              actionType: t.actionType,
              continue: t.continue,
            });

            let selectedToothNum = t.tooth.name.split("_")[2].substring(1, 4);

            let key = selectedToothNum.toString() + "_Movement";
            if (!logs[key]) {
              logs[key] = {};
              logs[key][MovementTypes.MESIALDISTAL] = 0;
              logs[key][MovementTypes.BUCCALLINGUAL] = 0;
              logs[key][MovementTypes.EXTRUSIONINTRUSION] = 0;
              logs[key][MovementTypes.ROTATION] = 0;
              logs[key][MovementTypes.ANGULATION] = 0;
              logs[key][MovementTypes.INCLINATION] = 0;
              logs[key][MovementTypes.LEFTHINGE] = 0;
              logs[key][MovementTypes.RIGHTHINGE] = 0;
            }
            if (!logs[key].hasOwnProperty("attachment")) {
              logs[key]["attachment"] = {};
            }
            logs[key]["attachment"][t.attachmentID] = {
              action: action,
              type: attachment.name,
            };

            // if (logs[key]) {
            //   const obj = Object.assign({}, logs[key]);
            //   delete logs[key];
            //   obj["attachment"][t.attachmentID] = {
            //     action: action,
            //     type: attachment.name,
            //   };
            //   logs[key] = obj;
            // } else {
            //   logs[key] = {};
            //   if (!logs[key]["attachment"]) {
            //     logs[key]["attachment"] = {};
            //   }
            //   logs[key]["attachment"][t.attachmentID] = {
            //     action: action,
            //     type: attachment.name,
            //   };
            // }
            setLogs(logs);
          } else if (t.action === "move") {
            for (let i = 0; i < t.tooth.children[0].children.length; i++) {
              if (t.tooth.children[0].children[i].name == t.attachmentName) {
                redoMovementList.push({
                  tooth: t.tooth,
                  action: t.action,
                  actionType: t.actionType,
                  attachmentName: t.tooth.children[0].children[i].name,
                  relativePosition: roundVector(
                    t.tooth.children[0].children[i].position.clone(),
                  ),
                  relativeRotation: roundVector(
                    t.tooth.children[0].children[i].rotation.clone(),
                  ),
                });
                removeListenersFrom(t.tooth.children[0].children[i]);
                t.tooth.children[0].children[i].removeFromParent();
              }

              let attachment;
              let isExistingAttachment = false;
              for (let i = 0; i < attachmentsObjects.length; i++) {
                if (attachmentsObjects[i].name === t.attachmentName) {
                  attachment = attachmentsObjects[i].clone();
                }
              }
              if (!attachment) {
                // old attachment
                isExistingAttachment = true;
                attachment =
                  attachmentArray[
                    t.tooth.name.split("_")[2].substring(1)
                  ][0].clone();
                attachment.material = oldAttachmentMaterial;
              } else {
                attachment.material = attachmentMaterial;
              }
              t.tooth.children[0].add(attachment);
              subscribeAttachmentToListener(attachment);

              attachment.position.copy(t.relativePosition);
              attachment.rotation.copy(t.relativeRotation);
              attachment.visible = true;

              let selectedToothNum = t.tooth.name.split("_")[2].substring(1, 4);
              let action;
              if (attachmentArray[selectedToothNum]?.length > 0) {
                if (isExistingAttachment) {
                  action = "";
                } else {
                  action = "remove";
                }
              } else {
                action = "add";
              }

              let key = selectedToothNum.toString() + "_Movement";
              if (logs[key]) {
                const obj = Object.assign({}, logs[key]);
                delete logs[key];
                obj["attachment"] = {
                  action: action,
                  type: attachment.name,
                };
                logs[key] = obj;
              } else {
                logs[key] = {};
                logs[key]["attachment"] = {
                  action: action,
                  type: attachment.name,
                };
              }
              setLogs(logs);
            }
          } else if (t.action === "rotate") {
            for (let i = 0; i < t.tooth.children[0].children.length; i++) {
              if (
                t.tooth.children[0].children[i].name == t.attachmentName &&
                t.attachmentID === t.tooth.children[0].children[i].customID
              ) {
                redoMovementList.push({
                  tooth: t.tooth,
                  action: t.action,
                  actionType: t.actionType,
                  attachmentID: t.attachmentID,
                  attachmentName: t.tooth.children[0].children[i].name,
                  rotation: t.tooth.children[0].children[i].rotation.clone(),
                  continue: t.continue,
                });
                t.tooth.children[0].children[i].rotation.copy(t.rotation);
                break;
              }
            }
          }

          attContinue = t.continue;
          continue;
          // reflectAttachments(
          //   t.tooth,
          //   t.attachment,
          //   t.initialAttachmentPosition,
          //   t.initialAttachmentRotation,
          //   t.attachmentPosition,
          //   t.attachmentRotation,
          //   t.action,
          //   scene,
          //   attachmentArray,
          //   GLBData,
          //   0,
          // );
          if (undoMovementList.length === 0) {
            reflectToChangelog(t);
          }
          // console.log(undoMovementList, t.attachmentRotationMatrix);
        }
        // else if (t.actionType === MovementTypes.ATTACHMENTS) {
        //   reflectAttachments(
        //     t.tooth,
        //     t.attachment,
        //     t.initialAttachmentPosition,
        //     t.initialAttachmentRotation,
        //     t.attachmentPosition,
        //     t.attachmentRotation,
        //     t.action,
        //     scene,
        //     attachmentArray,
        //     GLBData,
        //     0,
        //   );
        //   if (undoMovementList.length === 0) {
        //     reflectToChangelog(t);
        //   }
        //   // console.log(undoMovementList, t.attachmentRotationMatrix);
        // }
        if (addToList) {
          redoMovementList.push(t);
        }
        break;
      } else {
        let len = undoMovementList[undoMovementList.length - 1]?.length - 1;
        if (
          undoMovementList.length === 0 ||
          ((movementType !==
            undoMovementList[undoMovementList.length - 1][len]?.actionType ||
            (toothNum !==
              undoMovementList[undoMovementList.length - 1][len]?.tooth.name
                .split("_")[2]
                .substring(1, 4) &&
              !undoMovementList[undoMovementList.length - 1][len]
                ?.isChunckMovement)) &&
            !undoMovementList[undoMovementList.length - 1][len]?.RM)
        ) {
          break;
        }
        const r = undoMovementList.pop();
        redoMovementList.push([]);
        let t;
        for (let i = 0; i <= len; i++) {
          t = r[i];
          if (t.movement) {
            t.tooth.position.add(t.movement);
            movedTeeth.add(t.tooth.name);

            reflectToChangelog(t);
          } else if (t.degrees) {
            rotateTooth(
              t.rotationPoint,
              t.teethMovementRotationDirection,
              t.degrees,
              t.tooth,
            );
            movedTeeth.add(t.tooth.name);

            reflectToChangelog(t);
            // rotateAroundPoint(t.tooth, t.rotationPoint, t.teethMovementRotationDirection, t.degrees, true)
          } else if (t.actionType === MovementTypes.LOCK) {
            setControls3D("selectedTooth", t.tooth);
            lockTooth(true, t.tooth);
          } else if (t.actionType === MovementTypes.IPR) {
            if (t.from < 17) {
              for (let i = 0; i < newIprOverLays[0]["t" + t.from].length; i++) {
                if (
                  newIprOverLays[0]["t" + t.from][i].step ===
                  newIprOverLays[0]["t" + t.from].length - 1
                ) {
                  newIprOverLays[0]["t" + t.from][i].amount =
                    newIprOverLays[0]["t" + t.from][i].amount -
                    (t.amount - t.preAmount);
                  break;
                }
              }
            } else {
              for (let i = 0; i < newIprOverLays[1]["t" + t.from].length; i++) {
                if (
                  newIprOverLays[1]["t" + t.from][i].step ===
                  newIprOverLays[1]["t" + t.from].length - 1
                ) {
                  newIprOverLays[1]["t" + t.from][i].amount =
                    newIprOverLays[1]["t" + t.from][i].amount -
                    (t.amount - t.preAmount);
                  break;
                }
              }
            }
            reflectToChangelog(t);
          }
          if (addToList) {
            redoMovementList[redoMovementList.length - 1].push(t);
          } else {
            redoMovementList.pop();
          }
        }
      }
    }
    if (addToList && heatMapManager) {
      generateHeatmapsByName(movedTeeth);
    }
    prepareIPRs3DControls(null, newIprOverLays);
    setIprOverlays(newIprOverLays);
    setGlobalIprOverLays(newIprOverLays);
  }

  function undoWithOrder() {
    // for hamzeh's revert injection
    undo(false);
  }

  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`controls.${group}.${key}`);
  };
  return (
    <div className="bounty_urr">
      <div
        id="undo"
        onClick={() => {
          undo(), setAutoSave();
        }}
        className="bounty_undo"
      >
        <Undo />
      </div>
      <div
        id="redo"
        onClick={() => {
          redo(), setAutoSave();
        }}
        className="bounty_redo"
      >
        <Redo />
      </div>
      <ResetModal
        title={getContent("labels", "reset_modifications")}
        primaryActionText={getContent("actions", "reset")}
        primaryAction={() => {
          reset();
          clearAutoSave(), toggleReset();
        }}
        secondaryActionText={getContent("actions", "cancel")}
      >
        {getContent(
          "labels",
          "are_you_sure_you_want_to_reset_all_of_your_modifications_to_the_treatment_plan",
        )}
      </ResetModal>
      <div id="reset" onClick={toggleReset} className="bounty_reset">
        <Reset />
      </div>
    </div>
  );
}

export function getAttachmentByID(attachmentGroup, ID) {
  for (
    let attachmentIndex = 0;
    attachmentIndex < attachmentGroup.children.length;
    attachmentIndex++
  ) {
    if (attachmentGroup.children[attachmentIndex].customID == ID) {
      return attachmentGroup.children[attachmentIndex];
    }
  }
  return null;
}

export default URR;
